<template>
  <stepper-layout
    :stepTitle="'Rental Review'"
    :stepIcon="'receipt'"
  >
    <rental-info
      :currentStep="currentStep"
      :payload="payload"
      :unitFeatures="unitFeatures"
      :promotionMonth="promotionMonth"
      :updateNeeded="updateNeeded"
    />
    <v-layout class="subheading ml-2 my-4">
      <v-icon class="mr-2">error</v-icon>
      Please review all details of this transaction. If needed, you may navigate to an earlier step with one of the
      buttons below. If everything looks correct, click "Submit" to process payment.
    </v-layout>
  </stepper-layout>
</template>

<script>
import RentalInfo from "@/components/rent-unit/partials/RentalInfo";
import StepperLayout from "../../../layouts/StepperLayout";
import { mapState } from "vuex";

export default {
  props: {
    currentStep: {
      type: Number
    },
    payload: {
      type: Object
    },
    promotionMonth: {
      type: String,
      default: ""
    },
    updateNeeded: {
      type: Boolean,
      default: false
    }
  },

  components: {
    StepperLayout,
    RentalInfo
  },

  computed: {
    ...mapState({
      unit: state => state.facilities.unit,
      unitFeatures: state => state.facilities.unitFeatures
    })
  }
};
</script>
